import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle, MessageSquare, Headphones, BookOpen, Target, BarChart3, Upload, Zap, Users, Award, Clock, Star, Play } from "lucide-react";
const Index = () => {
  // ===== CONFIGURAÇÃO DE LINKS =====
  // Substitua os links abaixo pelos seus links reais
  const LINKS = {
    // ===== LINKS CONFIGURADOS PARA MAURICIA 2.0 =====

    // 🎆 TESTE GRATUITO - Link para página de planos
    testeFree: "https://google-ai-studio--malcosta.replit.app/planos",
    // 💰 PLANOS PAGOS - Todos direcionam para a página de planos
    planoMensal: "https://google-ai-studio--malcosta.replit.app/planos",
    planoAnual: "https://google-ai-studio--malcosta.replit.app/planos",
    trilhaIA: "https://google-ai-studio--malcosta.replit.app/planos",
    coachingExclusivo: "https://google-ai-studio--malcosta.replit.app/planos",
    // 🌐 PLATAFORMA PRINCIPAL - Link direto para a aplicação
    plataforma: "https://google-ai-studio--malcosta.replit.app",
    // 🎥 VÍDEO DEMONSTRAÇÃO - Apresentação e tutorial da MauricIA 2.0
    videoYoutube: "https://youtu.be/jPHpAaPdbls",
    // 📱 CONTATO E REDES SOCIAIS - Manter como exemplo (pode atualizar depois)
    whatsapp: "https://wa.me/5511999999999",
    instagram: "https://instagram.com/mauriciacacd",
    youtube: "https://youtube.com/@mauriciacacd",
    maisInfo: "mailto:contato@mauricia.com.br"
  };

  // Função para abrir links
  const openLink = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const features = [
    {
      icon: <Zap className="h-6 w-6" />,
      title: "Geração de Questões",
      description: "Funcionalidade PRINCIPAL: Crie questões Certo/Errado para treino de 1ª Fase e questões discursivas de 60 ou 40 linhas para 2ª Fase. Treinado no formato, estilo e bibliografia autorizada do CACD, com Google Search para temas atuais."
    },
    {
      icon: <MessageSquare className="h-6 w-6" />,
      title: "Chat Interativo",
      description: "Tire dúvidas pontuais sobre qualquer tema do edital. A IA responde com base na bibliografia autorizada do CACD e nas metodologias comprovadas de preparação, sempre no formato e estilo oficial do concurso."
    },
    {
      icon: <BookOpen className="h-6 w-6" />,
      title: "Aprendizado Guiado",
      description: "Aprenda conceitos complexos passo a passo através de tutoria socrática. A IA conduz você por um caminho de descoberta, fazendo perguntas que estimulam o raciocínio antes de revelar as respostas. Treinado na bibliografia autorizada do CACD com Método baseado em Retrieval Practice (Testing Effect)."
    },
    {
      icon: <Target className="h-6 w-6" />,
      title: "Coaching Personalizado",
      description: "Receba orientação estratégica completa para sua preparação. O Coach analisa seu perfil, identifica pontos fortes e fracos, e cria um plano de estudos personalizado baseado nos Círculos Concêntricos, Leitura Densa e Progressão Cíclica. Utiliza bibliografia autorizada do CACD com Google Search para temas atuais."
    },
    {
      icon: <BookOpen className="h-6 w-6" />,
      title: "Resumos",
      description: "Gere material de revisão rápido e estruturado sobre qualquer tópico do edital. Ideal para consolidar o aprendizado e criar fichas de estudo. Os resumos seguem a estrutura exigida pelo CACD e incluem pontos-chave para memorização."
    },
    {
      icon: <BarChart3 className="h-6 w-6" />,
      title: "Revisão Inteligente",
      description: "Análise completa do seu desempenho. A IA cruza seus resultados nas questões objetivas (TPS) e discursivas para identificar padrões de erro, lacunas de conhecimento e temas que precisam de reforço. Receba um diagnóstico detalhado e um plano de ação específico para superar suas dificuldades."
    },
    {
      icon: <BarChart3 className="h-6 w-6" />,
      title: "Meu Desempenho",
      description: "Acompanhe sua evolução ao longo do tempo. Visualize estatísticas de acertos e erros por disciplina, identifique tendências e meça seu progresso. Histórico completo de todas as questões respondidas e correções recebidas."
    }
  ];
  
  const additionalResources = [
    {
      icon: <Upload className="h-6 w-6" />,
      title: "Upload de Documentos",
      description: "Envie PDFs e arquivos Word para análise. A IA extrai o conteúdo e usa como contexto para suas respostas, sempre mantendo o formato e estilo do CACD."
    },
    {
      icon: <CheckCircle className="h-6 w-6" />,
      title: "Correção Rigorosa",
      description: "Suas respostas discursivas são avaliadas seguindo os critérios oficiais da banca do CACD, com nota detalhada e feedback construtivo baseado na bibliografia autorizada."
    },
    {
      icon: <Star className="h-6 w-6" />,
      title: "Bibliografia Autorizada + Google Search",
      description: "Treinado na bibliografia oficial do CACD com acesso ao Google Search para temas atuais, garantindo respostas no formato, estilo e conteúdo exigidos pelo concurso."
    }
  ];
  const plans = [{
    name: "Teste Grátis",
    price: "R$ 0",
    period: "por 3 dias",
    features: ["Chat Interativo", "Resumos", "Meu Desempenho", "Revisão Inteligente", "Aprendizado Guiado"],
    description: "Experimente todos os recursos antes de assinar.",
    highlight: false
  }, {
    name: "Plano Mensal",
    price: "R$ 99,90",
    period: "/mês",
    features: ["Chat Interativo", "Resumos", "Meu Desempenho", "Revisão Inteligente"],
    description: "Flexibilidade para quem quer testar por mais tempo.",
    highlight: false
  }, {
    name: "Plano Anual",
    price: "R$ 799",
    period: "/ano (equivale a R$ 66,58/mês)",
    features: ["Chat Interativo", "Resumos", "Meu Desempenho", "Revisão Inteligente"],
    description: "Economia de 33% em relação ao plano mensal.",
    highlight: true,
    badge: "Mais Popular"
  }, {
    name: "Trilha da IA",
    price: "R$ 3.000",
    period: "por 30 semanas",
    features: ["Chat Interativo", "Resumos", "Meu Desempenho", "Revisão Inteligente", "Aprendizado Guiado"],
    description: "Para quem quer tutoria socrática e metodologia ativa de aprendizado.",
    highlight: false
  }, {
    name: "Coaching Exclusivo",
    price: "R$ 5.800",
    period: "por 30 semanas",
    features: ["Chat Interativo", "Resumos", "Meu Desempenho", "Revisão Inteligente", "Aprendizado Guiado", "Coaching Personalizado"],
    description: "O pacote completo para quem busca acompanhamento estratégico total.",
    highlight: false
  }];
  const modes = [{
    title: "Modo Texto",
    description: "Converse com a IA através de mensagens escritas. Faça perguntas, solicite explicações, peça questões de treino e receba correções detalhadas. Ideal para estudo focado e aprofundado.",
    icon: <MessageSquare className="h-8 w-8 text-primary" />
  }, {
    title: "Modo Áudio",
    description: "Tenha aulas completas por voz em tempo real. Diferente de simples perguntas e respostas, o modo áudio permite que você assista a verdadeiras aulas expositivas, como se estivesse em uma sala de aula particular. Escolha entre diferentes vozes e aprenda enquanto faz outras atividades.",
    icon: <Headphones className="h-8 w-8 text-primary" />
  }];
  const benefits = [{
    icon: <Award className="h-6 w-6 text-secondary" />,
    text: "A IA mais bem treinada para o CACD: Sistema especializado exclusivamente na preparação para a carreira diplomática"
  }, {
    icon: <Clock className="h-6 w-6 text-secondary" />,
    text: "18 anos de experiência: Metodologia refinada pelo Professor Maurício Costa ao longo de quase duas décadas"
  }, {
    icon: <Users className="h-6 w-6 text-secondary" />,
    text: "O melhor modelo de IA: Tecnologia de ponta especializada exclusivamente para o CACD"
  }, {
    icon: <Headphones className="h-6 w-6 text-secondary" />,
    text: "Aulas completas por áudio: Não apenas perguntas e respostas, mas verdadeiras aulas expositivas"
  }, {
    icon: <Star className="h-6 w-6 text-secondary" />,
    text: "Correção no padrão da banca: Feedback detalhado seguindo os critérios reais de avaliação"
  }];
  return <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b bg-white/95 backdrop-blur-sm sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img src="./images/WhatsApp Image 2025-08-22 at 23.04.40.jpeg" alt="Professor Maurício Costa" className="h-12 w-12 rounded-full" />
              <div>
                <h1 className="text-xl font-bold text-primary">Prof. Maurício Costa IA (MauricIA 2.0)</h1>
                <p className="text-sm text-muted-foreground">Diálogo Diplomático</p>
              </div>
            </div>
            <Button className="bg-primary hover:bg-primary/90" onClick={() => openLink(LINKS.testeFree)}>
              Começar Teste Grátis
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-20 px-4 hero-gradient text-white">
        <div className="container mx-auto text-center">
          <div className="flex justify-center mb-8">
            <img src="./images/WhatsApp Image 2025-08-22 at 23.04.40.jpeg" alt="Professor Maurício Costa" className="w-32 h-32 rounded-full border-4 border-white/20 shadow-glow" />
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6 xl:text-7xl">
            A IA Mais Bem Treinada Para o CACD
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto leading-relaxed">
            Prepare-se para a Carreira Diplomática com a inteligência artificial especializada 
            <span className="font-semibold">treinada na bibliografia autorizada do CACD</span>, que combina 
            <span className="font-semibold"> 18 anos de experiência</span> do Professor Maurício Costa e 
            <span className="font-semibold"> o melhor modelo de IA</span>.
          </p>
          <Button size="lg" className="bg-white text-primary hover:bg-white/90 text-lg px-8 py-4" onClick={() => openLink(LINKS.testeFree)}>
            Começar Teste Grátis de 3 Dias
          </Button>
        </div>
      </section>

      {/* Video Demo Section */}
      <section className="py-20 px-4 bg-muted/30">
        <div className="container mx-auto">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6 text-primary">
              Veja a MauricIA 2.0 em Ação
            </h2>
            <p className="text-xl text-muted-foreground mb-8">
              Assista à apresentação completa e tutorial de como usar a IA mais bem treinada para o CACD
            </p>
            
            {/* Video Container */}
            <div className="relative w-full max-w-4xl mx-auto">
              <div className="relative pb-[56.25%] h-0 overflow-hidden rounded-lg shadow-elegant">
                <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/jPHpAaPdbls" title="MauricIA 2.0 - Apresentação e Tutorial" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              </div>
            </div>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
              <Button size="lg" className="bg-primary hover:bg-primary/90 text-lg px-8 py-4" onClick={() => openLink(LINKS.testeFree)}>
                Começar Teste Grátis Agora
              </Button>
              <Button size="lg" variant="outline" className="text-lg px-8 py-4 border-primary text-primary hover:bg-primary hover:text-white" onClick={() => openLink(LINKS.videoYoutube)}>
                Assistir no YouTube
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Modes Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-primary">Modos de Interação</h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {modes.map((mode, index) => <Card key={index} className="shadow-elegant hover:shadow-glow transition-smooth">
                <CardHeader>
                  <div className="flex items-center space-x-4">
                    {mode.icon}
                    <CardTitle className="text-2xl">{mode.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground leading-relaxed">{mode.description}</p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 px-4 bg-muted/30">
        <div className="container mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-primary">Funcionalidades</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {features.map((feature, index) => <Card key={index} className="shadow-elegant hover:shadow-glow transition-smooth">
                <CardHeader>
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-primary/10 rounded-lg text-primary">
                      {feature.icon}
                    </div>
                    <CardTitle className="text-xl">{feature.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground">{feature.description}</p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Additional Resources Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-primary">Recursos Adicionais</h2>
          <div className="grid md:grid-cols-1 lg:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {additionalResources.map((resource, index) => (
              <Card key={index} className="shadow-elegant hover:shadow-glow transition-smooth">
                <CardHeader>
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-secondary/10 rounded-lg text-secondary">
                      {resource.icon}
                    </div>
                    <CardTitle className="text-lg">{resource.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-muted-foreground text-sm">{resource.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-primary">Planos e Preços</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 max-w-7xl mx-auto">
            {plans.map((plan, index) => <Card key={index} className={`relative shadow-elegant hover:shadow-glow transition-smooth ${plan.highlight ? 'ring-2 ring-primary scale-105' : ''}`}>
                {plan.badge && <Badge className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-secondary text-secondary-foreground">
                    {plan.badge}
                  </Badge>}
                <CardHeader className="text-center">
                  <CardTitle className="text-2xl">{plan.name}</CardTitle>
                  <div className="text-3xl font-bold text-primary">{plan.price}</div>
                  <p className="text-sm text-muted-foreground">{plan.period}</p>
                </CardHeader>
                <CardContent className="space-y-4">
                  <p className="text-sm text-muted-foreground">{plan.description}</p>
                  <ul className="space-y-2">
                    {plan.features.map((feature, featureIndex) => <li key={featureIndex} className="flex items-center space-x-2">
                        <CheckCircle className="h-4 w-4 text-green-500" />
                        <span className="text-sm">{feature}</span>
                      </li>)}
                  </ul>
                  <Button className={`w-full ${plan.highlight ? 'bg-primary hover:bg-primary/90' : 'bg-secondary hover:bg-secondary/90 text-secondary-foreground'}`} onClick={() => {
                if (index === 0) openLink(LINKS.testeFree);else if (index === 1) openLink(LINKS.planoMensal);else if (index === 2) openLink(LINKS.planoAnual);else if (index === 3) openLink(LINKS.trilhaIA);else if (index === 4) openLink(LINKS.coachingExclusivo);
              }}>
                    {index === 0 ? 'Começar Teste Grátis' : 'Escolher Plano'}
                  </Button>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 px-4 bg-muted/30">
        <div className="container mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-primary">Por Que Escolher a MauricIA 2.0?</h2>
          <div className="max-w-4xl mx-auto space-y-6">
            {benefits.map((benefit, index) => <div key={index} className="flex items-start space-x-4 p-6 bg-white rounded-lg shadow-elegant">
                {benefit.icon}
                <p className="text-muted-foreground leading-relaxed">{benefit.text}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 hero-gradient text-white">
        <div className="container mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6">
            Comece agora seu teste grátis de 3 dias
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            Descubra como a IA pode transformar sua preparação para o CACD.
          </p>
          <Button size="lg" className="bg-white text-primary hover:bg-white/90 text-lg px-8 py-4" onClick={() => openLink(LINKS.testeFree)}>
            Começar Teste Grátis
          </Button>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-4 bg-primary text-white">
        <div className="container mx-auto text-center">
          <div className="flex items-center justify-center space-x-4 mb-6">
            <img src="./images/Gemini_Generated_Image_cynkaicynkaicynk.png" alt="MauricIA 2.0 Logo" className="h-10 w-10 rounded-full" />
            <div>
              <h3 className="text-lg font-bold">Diálogo Diplomático</h3>
              <p className="text-sm opacity-80">Professor Maurício Costa IA - MauricIA 2.0</p>
            </div>
          </div>
          <p className="text-sm opacity-80">
            © 2024 MauricIA 2.0. Todos os direitos reservados. Preparação especializada para o CACD.
          </p>
        </div>
      </footer>
    </div>;
};
export default Index;